export const SIGN_IN = "/signin";
export const HOME = "/";
export const CATEGORIES = "/categories"
export const CATEGORY = "/categories/:id"
export const TAGS = "/tags"
export const USERS = "/users"
export const USER = "/users/:id"



// WEBPACK FOOTER //
// ./src/constants/routes.ts